import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconArrowDiagonalUpRightStyle0 = cosmosIconCss;

const CosmosIconArrowDiagonalUpRight$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArrowDiagonalUpRight extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '15c46dad7adbe4a66a69ceb5266360bf9415f0d3', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5de972a32adbc51944314834d7888160fd0fd0ab', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ac93cf517ac7a867926ac9504b22ab75d8a7307b', d: "M14.65 8.416v4.448a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-6.5a.498.498 0 0 0-.148-.355.498.498 0 0 0-.356-.15h-6.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h4.44l-7.58 7.58a.5.5 0 0 0 0 .707l.354.353a.5.5 0 0 0 .707 0l7.583-7.583Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconArrowDiagonalUpRightStyle0; }
}, [1, "cosmos-icon-arrow-diagonal-up-right", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-arrow-diagonal-up-right"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-arrow-diagonal-up-right":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArrowDiagonalUpRight$1);
            }
            break;
    } });
}

const CosmosIconArrowDiagonalUpRight = CosmosIconArrowDiagonalUpRight$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArrowDiagonalUpRight, defineCustomElement };
